import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageProvider";
import { getNewsThumbImageUrl } from "../../utils/imageUrl";
import { formatNewsDate, toNewsSlug } from "../../utils/news";
import "./NewsCard.sass";

function NewsCard({ news }) {
    const { language, localizedPath, t } = useTranslation();
    const imageAlt = news?.title || t("news.title");
    const preview = news?.content || news?.excerpt || "";

    return (
        <article className="news-card card-common">
            <Link to={localizedPath(`/noutati/${toNewsSlug(news)}`)} className="news-card__image-link">
                <img src={getNewsThumbImageUrl(news?.image_url)} alt={imageAlt} className="news-card__image" />
            </Link>
            <div className="news-card__content">
                {news?.published_at && <time className="news-card__date">{formatNewsDate(news.published_at, language)}</time>}
                <h3 className="news-card__title">
                    <Link to={localizedPath(`/noutati/${toNewsSlug(news)}`)}>{news?.title}</Link>
                </h3>
                {preview && <p className="news-card__excerpt">{preview}</p>}
                <Link to={localizedPath(`/noutati/${toNewsSlug(news)}`)} className="news-card__link">
                    {t("news.readMore")}
                </Link>
            </div>
        </article>
    );
}

export default NewsCard;
